/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./refund-dialog.vue?vue&type=template&id=97bc83ca&scoped=true&"
import script from "./refund-dialog.vue?vue&type=script&lang=js&"
export * from "./refund-dialog.vue?vue&type=script&lang=js&"
import style0 from "./refund-dialog.vue?vue&type=style&index=0&id=97bc83ca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97bc83ca",
  null
  
)

export default component.exports